require("./src/prism-epi-ds-theme.scss");

/* eslint-env browser */

export const shouldUpdateScroll = () => {
    document.querySelector(".epi-uif-workspace").scrollTo(0, 0);
    // Return nothing because we don't want to replace the behavior, we just want to extend it
};
